// src/components/alert/IntegrityOC.tsx

import {
  Alert,
  AlertProps,
  AlertTitle,
  Collapse,
  LinearProgress,
  Typography,
} from '@mui/material'
import { useEffect, useState } from 'react'

import { ContractName, ContractPool } from '@/types/domain/contract'
import { FolderName, FolderPool } from '@/types/domain/folder'

import { useContractPool, useFolderPool } from '../../hooks'
import { usePreloader } from '../context/preloader'

export const IntegrityOC = () => {
  const cPool: ContractPool = useContractPool()
  const fPool: FolderPool = useFolderPool()

  const { isLoading } = usePreloader()

  const SEVERITY_SUCCESS: AlertProps['severity'] = 'success'
  const SEVERITY_ERROR: AlertProps['severity'] = 'error'
  const SEVERITY_LOADING: AlertProps['severity'] = 'info'

  const [severity, setSeverity] =
    useState<AlertProps['severity']>(SEVERITY_LOADING)
  const [fNames, setFNames] = useState<FolderName[]>([])
  const [cNames, setCNames] = useState<ContractName[]>([])

  useEffect(() => {
    if (isLoading === true) {
      setSeverity(SEVERITY_LOADING)
      return
    }

    setFNames(fPool.map(i => i.attributes.name).sort())
    setCNames(cPool.map(i => i.attributes.name).sort())

    if (cPool.length === fPool.length) setSeverity(SEVERITY_SUCCESS)
    if (cPool.length !== fPool.length) setSeverity(SEVERITY_ERROR)
  }, [cPool, fPool, isLoading])

  return (
    <Alert severity={severity}>
      <AlertTitle>Synchronizität von Gebäuden & Verträgen</AlertTitle>

      <Collapse in={isLoading}>
        <LinearProgress />
      </Collapse>

      <Collapse in={!isLoading && severity === SEVERITY_SUCCESS}>
        <Typography>
          Gleiche Anzahl von Gebäuden ({fPool.length}) und Verträgen (
          {cPool.length}) erkannt.
        </Typography>
      </Collapse>

      <Collapse in={!isLoading && severity !== SEVERITY_SUCCESS}>
        <Typography>
          Ungleiche Anzahl von Gebäuden ({fPool.length}) und Verträgen (
          {cPool.length}) erkannt.
        </Typography>
      </Collapse>

      <Collapse in={!isLoading}>
        <Typography sx={{ py: 5 }}>
          Ermittle Gebäude und Verträge, die kein Paar bilden:
        </Typography>

        <Typography>
          <strong>
            GEBÄUDE OHNE GLEICHNAMIGEN VERTRAG (
            {fNames.filter(f => !cNames.includes(f)).length})
          </strong>
        </Typography>
        <br />
        {fNames
          .filter(f => !cNames.includes(f))
          .join(', ')
          .split('<br/>')}
        <br />
        <br />
        <Typography>
          <strong>
            VERTRÄGE OHNE GLEICHNAMIGES GEBÄUDE (
            {cNames.filter(f => !fNames.includes(f)).length})
          </strong>
        </Typography>
        <br />
        {cNames
          .filter(f => !fNames.includes(f))
          .join(', ')
          .split('<br/>')}
      </Collapse>
    </Alert>
  )
}
